export default __webpack_public_path__ + "static/media/entry.94b1e7d0.webp";